import React, {useState} from 'react';
import PropTypes from 'prop-types';

const StepHandler = ({steps = [], payload = {}, showGlobalErrorMessage}) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [stepContext, setStepContext] = useState({...payload});
  const stepsNumber = steps.length;
  const Component = steps[currentStep];

  const goNext = () => {
    if (currentStep + 1 < stepsNumber) {
      setCurrentStep(currentStep + 1);
    }
  };

  const pushStepContext = (newContext = {}) => {
    if (typeof newContext !== 'object') return;
    setStepContext({...stepContext, ...newContext})
  };

  return (
    <Component
      goNext={goNext}
      stepContext={stepContext}
      contextActions={{pushStepContext}}
      showGlobalErrorMessage={showGlobalErrorMessage}
    />
  )
};

StepHandler.propTypes = {
  steps: PropTypes.array,
  payload: PropTypes.object,
};

export default StepHandler;


